import { glacierPolicyApiGetPolicyOptions } from '@/lib/heyapi/@tanstack/react-query.gen';
import { glacierPolicyApiGetLatestTransactionSummary } from '@/lib/heyapi/';

import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { HeaderView } from './components/HeaderView';

export const Header = () => {
  const { id } = useParams();

  const { data } = useQuery({
    ...glacierPolicyApiGetPolicyOptions({
      path: {
        account_id: id!,
      },
    }),
  });

  const summaryResponse = useQuery({
    queryKey: ['latestTransactionSummary', id],
    queryFn: () =>
      glacierPolicyApiGetLatestTransactionSummary({
        path: {
          account_id: id!,
        },
      }),
  });

  if (!data) {
    return <p>Loading...</p>;
  }

  return (
    <HeaderView
      policy={data}
      latestTransactionSummary={summaryResponse.data?.data}
    />
  );
};
